// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"319":"b491aa4a","378":"7b4d07f7","559":"f2197f48","876":"347e950b"}[chunkId] + ".chunk.css";
};